import React, { useState, useEffect, useMemo, useRef } from "react";
import moment from "moment";
// others
import { Loading } from "./index";
import Button from "../../../../molecules/Button";
import { DownloadOutlined } from "@ant-design/icons";
import PdfView from "../../../../molecules/PDFViewer/pdvViewNew";
import { Card, Row, Col, Form, message, Image, Upload, Space, Radio, Switch, Tag, Tooltip, Spin, Select } from "antd";
import { useForm, useWatch } from "react-hook-form";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { InputNumberFieldV2 as InputNumberField } from "../../../../atoms/FormElement/InputNumberField";
import { dateBookingDDMMYYFormat } from "../utils";
import { calculatePaidAmountAndDueDate } from "../utils";
import { uploadDocumentMedia, getPresignedImage } from "../../../../../utils/media";
import { updateBooking, getBookingDetail } from "../../ducks/actions";

import { DateField, InputField, ReactSelectField, InputCheckbox } from "../../../../atoms/FormElement";

import { datePlaceholderddmmyyFormat } from "../utils";

interface IProps {
  renewal?: boolean;
  parentState: (obj: object) => void;
}

let initialState = {
  visible: false,
  authorizedSignatory: "",
};

var _ = require("lodash");

import { ExclamationCircleFilled, LinkOutlined, UploadOutlined } from "@ant-design/icons";
import { getMoveOutDetailService } from "../../../TerminationProcess/ducks/services";
import { PopupConfirm } from "../../../../atoms/Popup";
import { useTotalOverpaymentAmount } from "../../../Contracts/PostDatedCheques/ModifyPaymentStatus/hook/useTotalOverpaymentAmount";
import { formatCurrency } from "../../../../libs/utils";
import { useDebouncedAsync } from "../../../TerminationProcess/hooks/useDebouncedAsync";
import { usePendingRequestsActions } from "../../../PendingApprovalRequets/api/useRefreshPendingRequests";

const index = (props: IProps) => {
  // hooks initialization
  const dispatch: any = useDispatch();
  const { leaseId = "" } = useParams();
  const { refreshPendingRequests } = usePendingRequestsActions();
  const { bookingDetails } = useSelector((state: any) => state.newBooking);
  const { loading, totalOverpaymentRemaining, error } = useTotalOverpaymentAmount(bookingDetails?.tenantId);
  const [viewOrDownloadUrl, setViewOrDownloadUrl] = useState(null);
  const [openFileView, setOpenFileView] = useState(false);
  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const watchedValues = useWatch({
    control,
    name: ["overStayPenalty", "terminationPenalty"],
  });

  // states

  const [{ visible }, setState] = useState(initialState);
  const [uploadedDocData, setUploadedDocData] = useState(null);

  const updateState = (state: {}) => setState((prevState: any) => ({ ...prevState, ...state }));
  const [moveOutDetail, setMoveOutDetail] = useState(null);

  const parseCurrency = (input) => {
    if (input) {
      // Remove all non-numeric characters except the decimal point
      const numericValue = input;
      return parseFloat(numericValue || "0");
    } else {
      if (_.isEmpty(input)) {
        return null;
      } else {
        return 0;
      }
    }
  };

  const buildMoveOutBody = ({
    data,
    type,
    overStayPenaltyType,
    terminationPenaltyType,
    moveOutDetail,
    uploadedDocData,
    howShowFinalAmount,
    parseCurrency,
  }: any) => {
    const finalAmount = Number(parseFloat(howShowFinalAmount())?.toFixed(2));

    return {
      settlementSummary: {
        maintenancefee: parseCurrency(data?.maintenanceFee),
        refurbismentfee: parseCurrency(data?.refurbismentFee),
        otheradminfee: parseCurrency(data?.adminFee),
        deduction: parseCurrency(data?.waiver),
        settlementAmount: finalAmount,
        settlementAmountIsNegative: finalAmount > 0 ? "no" : "yes",
        overpaymentCredit: totalOverpaymentRemaining,
      },
      moveOutInspection: {
        date: data?.moveOutInspectionDate ? moment(data?.moveOutInspectionDate.$d).format("YYYY-MM-DD") : null,
        documentId: uploadedDocData?.documentId ?? null,
        moveOutConfirm: data?.moveOutConfirm,
      },
      vacatingDate: data?.moveOutDate ? moment(data?.moveOutDate.$d).format("YYYY-MM-DD") : null,
      settlementApproval: type !== 1 ? "yes" : "no",
      overStayPenalty: {
        type: overStayPenaltyType || moveOutDetail?.overStayPenalty?.type,
        amount: data?.overStayPenalty || moveOutDetail?.overStayPenalty?.amount,
        vat: moveOutDetail?.overStayPenalty?.vat,
      },
      earlyTerminationPenalty: {
        type: terminationPenaltyType || moveOutDetail?.earlyTerminationPenalty?.type,
        amount: data?.terminationPenalty || moveOutDetail?.earlyTerminationPenalty?.amount,
        vat: moveOutDetail?.earlyTerminationPenalty?.vat,
      },
      onlyBooking: true,
    };
  };

  const { loading: penaltyChangeLoading } = useDebouncedAsync({
    fn: async () => {
      const formValues = getValues();
      const body = buildMoveOutBody({
        data: formValues,
        type: 2,
        overStayPenaltyType,
        terminationPenaltyType,
        moveOutDetail,
        uploadedDocData,
        howShowFinalAmount,
        parseCurrency,
      });
      let checkOverStay = overStayPenaltyType || moveOutDetail?.overStayPenalty?.type;
      let terminationType = terminationPenaltyType || moveOutDetail?.earlyTerminationPenalty?.type;
      let response = null;
      if (checkOverStay === "percentage" && formValues?.overStayPenalty <= 100) {
        response = await dispatch(updateBooking({ leaseId, body }));
      }

      if (terminationType === "month" && formValues?.overStayPenalty <= 12) {
        response = await dispatch(updateBooking({ leaseId, body }));
      }

      if (terminationPenaltyType !== "month" || overStayPenaltyType !== "percentage") {
        response = await dispatch(updateBooking({ leaseId, body }));
      }

      if (response?.data?.code === 200) {
        getMoveOutDetail();
      }

      return response;
    },
    delay: 800,

    params: watchedValues, // 🔥 triggers when values change
  });

  const onSubmit = async (data: any, type) => {
    if (
      data?.moveOutConfirm === true &&
      data?.moveOutConfirm !== "" &&
      data?.moveOutInspectionDate !== "" &&
      data?.moveOutInspectionDate &&
      data?.moveOutDate
    ) {
      PopupConfirm({
        title: `This action requires manager approval.`,
        onOk: async () => {
          try {
            updateState({ visible: true });
            let dataCopy = { ...(data || getValues()) };
            // let body = {
            //   settlementSummary: {
            //     maintenancefee: parseCurrency(dataCopy?.maintenanceFee),
            //     refurbismentfee: parseCurrency(dataCopy?.refurbismentFee),
            //     otheradminfee: parseCurrency(dataCopy?.adminFee),
            //     deduction: parseCurrency(dataCopy?.waiver),
            //     settlementAmount: Number(parseFloat(howShowFinalAmount())?.toFixed(2)),
            //     settlementAmountIsNegative: Number(parseFloat(howShowFinalAmount())?.toFixed(2)) > 0 ? "no" : "yes",
            //   },
            //   moveOutInspection: {
            //     date: dataCopy?.moveOutInspectionDate
            //       ? moment(dataCopy?.moveOutInspectionDate.$d).format("YYYY-MM-DD")
            //       : null,
            //     documentId: uploadedDocData?.documentId ? uploadedDocData?.documentId : null,
            //     moveOutConfirm: data?.moveOutConfirm,
            //   },
            //   vacatingDate: dataCopy?.moveOutDate ? moment(dataCopy?.moveOutDate.$d).format("YYYY-MM-DD") : null,
            //   settlementApproval: type !== 1 ? "yes" : "no",
            //   overStayPenalty: {
            //     type: overStayPenaltyType || moveOutDetail?.overStayPenalty?.type,
            //     amount: data?.overStayPenalty,
            //     vat: moveOutDetail?.overStayPenalty?.vat,
            //   },
            //   earlyTerminationPenalty: {
            //     type: terminationPenaltyType || moveOutDetail?.earlyTerminationPenalty?.type,
            //     amount: data?.terminationPenalty,
            //     vat: moveOutDetail?.earlyTerminationPenalty?.vat,
            //   },
            //   onlyBooking: true,
            // };
            const body = buildMoveOutBody({
              data: dataCopy,
              type,
              overStayPenaltyType,
              terminationPenaltyType,
              moveOutDetail,
              uploadedDocData,
              howShowFinalAmount,
              parseCurrency,
            });
            const response = await dispatch(updateBooking({ leaseId, body: body }));

            if (response?.data?.code === 200) {
              dispatch(getBookingDetail(leaseId + `?moveout=yes`));
              await refreshPendingRequests();
              message.success(response.data.message);
              updateState({ visible: false });
              props.parentState({
                modalPayload: {
                  iKey: "",
                  title: "",
                  extraText: "",
                  open: false,
                },
              });
            }
          } catch (error) {
            updateState({ visible: false });
            props.parentState({ visible: false });
            message.error(error.response?.data?.error || error.response?.data?.message);
          }
        },
        okText: "Yes",
        onCancel() {
          updateState({ visible: false });
          props.parentState({ visible: false });
        },
      });
    } else if (
      data?.moveOutConfirm === true &&
      data?.moveOutConfirm !== "" &&
      (data?.moveOutInspectionDate === "" || !data?.moveOutInspectionDate) &&
      data?.moveOutDate
    ) {
      message.error("Enter Move-out Inspection Date");
      return false;
    } else {
      message.error("please mark complete before submit");
      return false;
    }
  };

  const penaltyOption = [
    {
      label: "Early",
      value: "early",
    },
    {
      label: "Late",
      value: "late",
    },
    {
      label: "Natural",
      value: "natural",
    },
  ];

  const { totalPaidAmount, lastPaidDate, securityDepositAmount, securityDepositDate } = useMemo(
    () => calculatePaidAmountAndDueDate(moveOutDetail?.paymentSchedule),
    [moveOutDetail?.actualRentDue],
  );

  const fileProps = {
    className: "file-upload",
    name: "file",
    accept: ".jpg,.png,.jpeg,.pdf",
    multiple: false,
    showUploadList: false,
    onChange(info) {
      const { status } = info.file;
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} Please upload only image file`);
      }
    },

    beforeUpload: async (file) => {
      try {
        let uploadConfirmation = await uploadDocumentMedia({
          file_asset: file,
        });
        if (uploadConfirmation?.data?.code === 200) {
          message.success(`file uploaded successfully.`);
          setUploadedDocData(uploadConfirmation?.data?.result);
        }

        return false;
      } catch ({ response }) {
        message.error(response?.data?.error);
      }
    },
  };

  const preViewDoc = async (docId) => {
    let documentId = uploadedDocData?.documentId ? uploadedDocData?.documentId : docId;
    const url = await getPresignedImage([documentId]);
    if (url && url.length > 0) {
      window.open(url[0], "_blank");
    }
  };

  let diffBtwRentDueAndRentReceived = moveOutDetail?.actualRentDue ? moveOutDetail?.actualRentDue : 0 - totalPaidAmount;
  let terminationAndPenaltySum =
    moveOutDetail?.termination?.totalterminationPaneltyAmount + moveOutDetail?.overstay?.totalOverStayPaneltyAmount;

  let [vacatingDate, seVacatingDate] = useState(bookingDetails?.vacatingDate);
  const [adminSidePaid, setAdminSidePaid] = useState(0);
  const [tenantSidePaid, setTenantSidePaid] = useState(0);
  const [maintenanceCharges, setMaintenanceCharges] = useState(0);
  const [refurbismentCharges, setRefurbismentCharges] = useState(0);
  const [adminCharges, setAdminCharges] = useState(0);
  const [deductionCharges, setDeductionCharges] = useState(0);
  const [terminationPenaltyType, setTerminationPenaltyType] = useState(null);
  const [overStayPenaltyType, setOvertStayPenaltyType] = useState(null);

  const howShowFinalAmount = () => {
    return (adminSidePaid - tenantSidePaid)?.toFixed(2);
  };

  const getAdminPaidCharges = () => {
    return (
      maintenanceCharges + diffBtwRentDueAndRentReceived + refurbismentCharges + adminCharges + terminationAndPenaltySum
    );
  };

  const setFinalAmount = (value, type) => {
    if (type === 1) {
      setMaintenanceCharges(parseCurrency(value));
    } else if (type === 2) {
      setRefurbismentCharges(parseCurrency(value));
    } else if (type === 3) {
      setAdminCharges(parseCurrency(value));
    } else if (type === 4) {
      setDeductionCharges(parseCurrency(value));
    }
  };

  const getMoveOutDetail = async () => {
    let response = await getMoveOutDetailService(leaseId, vacatingDate?.slice(0, 10));
    if (response) {
      response?.vacatingDat && setValue("moveOutDate", response?.vacatingDate);
      maintenanceCharges === 0 &&
        setMaintenanceCharges(
          response?.settlementSummary?.maintenancefee ? response?.settlementSummary?.maintenancefee : 0,
        );
      refurbismentCharges === 0 &&
        setRefurbismentCharges(
          response?.settlementSummary?.refurbismentfee ? response?.settlementSummary?.refurbismentfee : 0,
        );
      adminCharges === 0 &&
        setAdminCharges(response?.settlementSummary?.otheradminfee ? response?.settlementSummary?.otheradminfee : 0);
      deductionCharges === 0 &&
        setDeductionCharges(response?.settlementSummary?.deduction ? response?.settlementSummary?.deduction : 0);
      setAdminSidePaid(getAdminPaidCharges());
      setMoveOutDetail(response);
    }
  };

  useEffect(() => {
    setAdminSidePaid(getAdminPaidCharges());
    setTenantSidePaid(deductionCharges + securityDepositAmount + totalPaidAmount + totalOverpaymentRemaining);
  }, [maintenanceCharges, refurbismentCharges, adminCharges, deductionCharges, moveOutDetail?.actualRentDue]);

  useEffect(() => {
    getMoveOutDetail();
  }, [vacatingDate]);

  const TooltipContent = ({ data, type }) => {
    if (type === 1) {
      return (
        <div>
          {/* totalOverStayPaneltyAmount	2040 type	*/}
          <span>Penalty type = {data?.type}</span>
          <br />
          <span>Amount per day = {data?.amount}</span>
          <br />
          <span>VAT = {data?.vat}</span>
          <br />
          <span>Overstay days = {data?.numberOfDays}</span>
          <br />
          <span>
            Overstay penalty vat ={" "}
            {`(OverStay days)% * (Amount per day) = ${formatCurrency(data?.overStayPaneltyVatAmount, { showZeros: true })}`}
          </span>
          <br />
          {data?.type?.toLowerCase() === "amount" ? (
            <>
              <span>
                Total overstay penalty ={" "}
                {`(Overstay days  * Amount per day) + VAT % = ${formatCurrency(data?.totalOverStayPaneltyAmount, { showZeros: true })}`}
              </span>
              <br />
            </>
          ) : (
            <>
              <span>
                Total overstay penalty ={" "}
                {`((Rent per day * overstayPenaltyAmount)/100) * Amount per day + VAT %  = ${formatCurrency(
                  data?.totalOverStayPaneltyAmount,
                  { showZeros: true },
                )}`}
              </span>
              <br />
            </>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <span>Penalty type = {data?.type}</span>
          <br />
          {
            <>
              {" "}
              <span>Penalty amount= {data?.amount}</span>
              <br />
            </>
          }
          <span>VAT = {data?.vat}</span>
          <br />
          <span>Number of days = {data?.numberOfDays}</span>
          <br />
          {data?.type?.toLowerCase() === "amount" ? (
            <>
              <span>
                Termination Penalty amount ={" "}
                {`(Number of days * Penalty amount) =  ${formatCurrency(data?.terminationPaneltyAmount, { showZeros: true })}`}
              </span>
              <br />
            </>
          ) : (
            <>
              <span>
                Termination Penalty amount ={" "}
                {`(Amount per month * Penalty amount) =  ${formatCurrency(data?.terminationPaneltyAmount, { showZeros: true })}`}
              </span>
              <br />
            </>
          )}
          <span>
            Penalty vat amount ={" "}
            {`(termination Penalty amount * VAT) / 100 = ${formatCurrency(data?.terminationPaneltyVatAmount, { showZeros: true })}`}
          </span>
          <br />

          <>
            <span>
              Total Termination penalty ={" "}
              {`(Termination Penalty amount * Penalty vat amount) = ${formatCurrency(
                data?.totalterminationPaneltyAmount,
                { showZeros: true },
              )}`}
            </span>
            <br />
          </>
        </div>
      );
    }
  };

  const isBooking = moveOutDetail && Object.keys(moveOutDetail).length > 0;

  const addonBefore = (options, defaultValue, onChange) => {
    return (
      <Select
        onChange={(e) => onChange(e)}
        className="beforAddOnSelect"
        defaultValue={defaultValue || options[0]}
        options={options || []}
        style={{ width: 100 }}
      />
    );
  };

  const overStayPenaltyValue = () => {
    if (moveOutDetail?.overstay?.type?.toLowerCase() === "percentage" && moveOutDetail?.overStayPenalty?.amount > 100) {
      return 100;
    } else {
      return moveOutDetail?.overStayPenalty?.amount;
    }
  };

  const terminationPaneltyValue = () => {
    if (moveOutDetail?.termination?.type?.toLowerCase() === "month") {
      // need to change it after discussion

      //return moveOutDetail?.overStayPenalty?.amount;
      return moveOutDetail?.earlyTerminationPenalty?.amount > 12 ? 12 : moveOutDetail?.earlyTerminationPenalty?.amount;
    } else {
      return moveOutDetail?.overStayPenalty?.amount;
    }
  };

  let moveOutType = moveOutDetail?.moveOutType?.toLowerCase();

  return (
    <>
      {!isBooking && (
        <Row gutter={24} className="loading">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "500px",
              width: "100%",
            }}
          >
            <Spin size="large" />
          </div>
        </Row>
      )}

      {isBooking && (
        <>
          <PdfView pdfData={viewOrDownloadUrl} openFileView={openFileView} setOpenFileView={setOpenFileView} />
          <Form
            layout="vertical"
            name="bookingform"
            scrollToFirstError
            className="bf-main"
            onFinish={handleSubmit(onSubmit)}
          >
            <Loading visible={visible} />

            <Col span={24}>
              <Row gutter={24}>
                <Col span={8}>
                  <ReactSelectField
                    control={control}
                    setValue={setValue}
                    label="Penalty Type"
                    fieldname="penaltyType"
                    selectOption={penaltyOption}
                    iProps={{ placeholder: "Select", isDisabled: true }}
                    rules={{ required: "Please select one" }}
                    validate={errors.penaltyType && "error"}
                    validMessage={errors.penaltyType && errors.penaltyType.message}
                    valueGot={penaltyOption?.find((item) => item?.value === moveOutDetail?.moveOutType?.toLowerCase())}
                  />
                </Col>

                <Col span={8}>
                  <DateField
                    control={control}
                    allowClear={false}
                    setValue={setValue}
                    label="Move-out Date"
                    fieldname="moveOutDate"
                    valueGot={dateBookingDDMMYYFormat(vacatingDate)}
                    onChange={(e) => seVacatingDate("20" + moment(e?.$d).format("YY-MM-DD"))}
                    iProps={{
                      format: datePlaceholderddmmyyFormat,
                      placeholder: datePlaceholderddmmyyFormat,
                    }}
                  />
                </Col>

                <Col span={7}>
                  <div
                    style={{
                      position: "absolute",
                      right: "14px",
                      top: "-10px",
                    }}
                  >
                    <InputCheckbox
                      fieldname="moveOutConfirm"
                      label="Complete"
                      control={control}
                      classes={`prm-checkbox`}
                      valueGot={
                        bookingDetails?.moveOutInspection ? bookingDetails?.moveOutInspection?.moveOutConfirm : false
                      }
                      iProps={{
                        className: `prm-checkbox`,
                      }}
                      setValue={setValue}
                    />
                    {(uploadedDocData?.documentId ||
                      (bookingDetails["moveOutInspection"] && bookingDetails?.moveOutInspection["documentId"])) && (
                      <Tooltip title="View" trigger="hover" showArrow={false}>
                        <Button
                          title={"View"}
                          label={<DownloadOutlined />}
                          type="button"
                          style={{
                            marginTop: "25px",
                            zIndex: 999,
                            top: "-43px",
                            left: "114px",
                          }}
                          className="ef-action-btn"
                          onClick={() =>
                            preViewDoc(
                              bookingDetails["moveOutInspection"] &&
                                (bookingDetails?.moveOutInspection["documentId"]
                                  ? bookingDetails?.moveOutInspection["documentId"]
                                  : uploadedDocData?.documentId),
                            )
                          }
                          myClassSet={true}
                        />
                      </Tooltip>
                    )}
                  </div>

                  <DateField
                    control={control}
                    setValue={setValue}
                    allowClear={false}
                    label="Move-out Inspection Date"
                    fieldname="moveOutInspectionDate"
                    valueGot={dateBookingDDMMYYFormat(
                      bookingDetails?.moveOutInspection && bookingDetails?.moveOutInspection["date"],
                    )}
                    iProps={{
                      format: datePlaceholderddmmyyFormat,
                      placeholder: datePlaceholderddmmyyFormat,
                    }}
                  />
                </Col>

                <Col span={1}>
                  <Space size={20}>
                    <Upload {...fileProps}>
                      <span>
                        {(bookingDetails["moveOutInspection"] && !bookingDetails?.moveOutInspection["documentId"]) ||
                        !uploadedDocData?.documentId ? (
                          <LinkOutlined style={{ marginTop: "30px", fontSize: "25px" }} />
                        ) : (
                          <Tooltip title="Upload" trigger="hover" showArrow={false}>
                            <Button
                              title={"upload"}
                              label={<UploadOutlined />}
                              type="button"
                              style={{ marginTop: "25px" }}
                              className="ef-action-btn"
                              myClassSet={true}
                            />
                          </Tooltip>
                        )}
                      </span>
                    </Upload>
                  </Space>
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    disabled={true}
                    setValue={setValue}
                    label="Lease Term"
                    fieldname="leaseTerm"
                    valueGot={`${moveOutDetail?.leaseTermDays ? moveOutDetail?.leaseTermDays : 0} days |  ${formatCurrency(
                      moveOutDetail?.leaseTerms?.contractAmount,
                      { showZeros: true },
                    )}`}
                    validate={errors.leaseTerm && "error"}
                    validMessage={errors.leaseTerm && errors.leaseTerm.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Days Occupied"
                    fieldname="daysOccupied"
                    valueGot={`${moveOutDetail?.daysOccupied ? moveOutDetail?.daysOccupied : 0} days`}
                    validate={errors.daysOccupied && "error"}
                    validMessage={errors.daysOccupied && errors.daysOccupied.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Rent Per Day"
                    disable={true}
                    fieldname="rentPerDay"
                    valueGot={` ${formatCurrency(moveOutDetail?.rentPerDay, { showZeros: true })}`}
                    validate={errors.rentPerDay && "error"}
                    validMessage={errors.rentPerDay && errors.rentPerDay.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Security Deposit"
                    fieldname="securityDeposit"
                    valueGot={`${securityDepositDate} |  ${formatCurrency(securityDepositAmount, { showZeros: true })}`}
                    validate={errors.securityDeposit && "error"}
                    validMessage={errors.securityDeposit && errors.securityDeposit.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Rent Received Until"
                    fieldname="rentReceived"
                    valueGot={`${lastPaidDate} |  ${formatCurrency(totalPaidAmount, { showZeros: true })}`}
                    validate={errors.rentReceived && "error"}
                    validMessage={errors.rentReceived && errors.rentReceived.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Actual Rent Due"
                    fieldname="rentDue"
                    valueGot={`${moveOutDetail?.daysOccupied ? moveOutDetail?.daysOccupied : 0} days | ${formatCurrency(
                      moveOutDetail?.actualRentDue,
                      { showZeros: true },
                    )}`}
                    validate={errors.rentDue && "error"}
                    validMessage={errors.rentDue && errors.rentDue.message}
                  />
                </Col>

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Unpaid Dues"
                    disable={true}
                    fieldname="otherUnpaidDuesAmount"
                    valueGot={`${formatCurrency(moveOutDetail?.otherUnpaidDuesAmount, { showZeros: true })}`}
                  />
                </Col>
                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Overpayment Credit"
                    disable={true}
                    fieldname="overPayment"
                    valueGot={`${formatCurrency(totalOverpaymentRemaining, { showZeros: true })}`}
                  />
                </Col>
                <Col span={8}>
                  <InputNumberField
                    control={control}
                    onChange={(e) => setFinalAmount(e, 1)}
                    format="currency"
                    fieldname="maintenanceFee"
                    defaultValue={`${formatCurrency(moveOutDetail?.settlementSummary?.maintenancefee, {
                      showZeros: true,
                      symbol: false,
                    })} `}
                    label="Maintenance Fee (if any)"
                  />
                </Col>

                <Col span={8}>
                  <InputNumberField
                    control={control}
                    onChange={(e) => setFinalAmount(e, 2)}
                    format="currency"
                    fieldname="refurbismentFee"
                    defaultValue={`${formatCurrency(moveOutDetail?.settlementSummary?.refurbismentfee, {
                      showZeros: true,
                      symbol: false,
                    })} `}
                    label="Refurbishment Fee (if any)"
                  />
                </Col>

                <Col span={8}>
                  <InputNumberField
                    control={control}
                    onChange={(e) => setFinalAmount(e, 3)}
                    format="currency"
                    fieldname="adminFee"
                    defaultValue={` ${formatCurrency(moveOutDetail?.settlementSummary?.otheradminfee, {
                      showZeros: true,
                      symbol: false,
                    })} `}
                    label="Other / Admin Fee (if any)"
                  />
                </Col>
                <Col span={8}>
                  <InputNumberField
                    control={control}
                    onChange={(e) => setFinalAmount(e, 4)}
                    format="currency"
                    fieldname="waiver"
                    defaultValue={` ${formatCurrency(moveOutDetail?.settlementSummary?.deduction, {
                      showZeros: true,
                      symbol: false,
                    })} `}
                    label="Deduction / Waiver"
                  />
                </Col>
                {moveOutType === "late" && (
                  <>
                    <Col span={8}>
                      <InputNumberField
                        control={control}
                        // onChange={(e) => setFinalAmount(e, 3)}
                        addonBefore={() =>
                          addonBefore(
                            moveOutDetail?.overstayPaneltyFields,
                            moveOutDetail?.overstay?.type,
                            setOvertStayPenaltyType,
                          )
                        }
                        inputNumberProps={{
                          min: 0,
                          max: overStayPenaltyType === "percentage" ? 100 : undefined,
                          precision: 2,
                        }}
                        // rules={
                        // overStayPenaltyType === "percentage" && {
                        // required: "Please enter amount",
                        //  min: { value: 0, message: "Percentage must be at least 0" },
                        //   max: { value: 100, message: "Percentage cannot exceed 100" },
                        //  }
                        // }
                        format="currency"
                        fieldname="overStayPenalty"
                        defaultValue={`${formatCurrency(overStayPenaltyValue(), {
                          showZeros: true,
                          symbol: false,
                        })} `}
                        stringMode={false}
                        label={`OverStay Penalty Type (inc vat ${moveOutDetail?.overStayPenalty?.vat}%)`}
                      />
                    </Col>
                    <Col span={8}>
                      <div style={{ position: "absolute", right: "14px", zIndex: 999 }}>
                        <Tooltip
                          placement="top"
                          overlayInnerStyle={{
                            backgroundColor: "#030218",
                            color: "#ffffff",
                            width: "450px",
                          }} // Custom styles
                          title={<TooltipContent data={moveOutDetail?.overstay} type={1} />}
                        >
                          <ExclamationCircleFilled title={moveOutDetail?.overstay?.overStayPaneltyFrom} />
                        </Tooltip>
                      </div>
                      <InputField
                        control={control}
                        setValue={setValue}
                        label="OverStay"
                        disabled={true}
                        fieldname="Overstay"
                        valueGot={
                          penaltyChangeLoading
                            ? "Loading..."
                            : `${
                                moveOutDetail?.overstay?.numberOfDays ? moveOutDetail?.overstay?.numberOfDays : 0
                              } days |  ${formatCurrency(moveOutDetail?.overstay?.totalOverStayPaneltyAmount, {
                                showZeros: true,
                              })}`
                        }
                      />
                    </Col>
                  </>
                )}

                {moveOutType === "early" && (
                  <>
                    <Col span={8}>
                      <InputNumberField
                        control={control}
                        // onChange={(e) => setFinalAmount(e, 3)}
                        addonBefore={() =>
                          addonBefore(
                            moveOutDetail?.terminationPaneltyFields,
                            moveOutDetail?.termination?.type,
                            setTerminationPenaltyType,
                          )
                        }
                        inputNumberProps={{
                          min: 0,
                          max: terminationPenaltyType === "month" ? 12 : undefined,
                          precision: 2,
                        }}
                        stringMode={false}
                        format="currency"
                        fieldname="terminationPenalty"
                        defaultValue={` ${formatCurrency(terminationPaneltyValue(), {
                          showZeros: true,
                          symbol: false,
                        })} `}
                        label={`Termination Penalty Type (inc vat ${moveOutDetail?.earlyTerminationPenalty?.vat}%)`}
                      />
                    </Col>
                    <Col span={8}>
                      <div
                        style={{
                          position: "absolute",
                          right: "14px",
                          zIndex: 9999,
                        }}
                      >
                        <Tooltip
                          placement="top"
                          overlayInnerStyle={{
                            backgroundColor: "#030218",
                            color: "#ffffff",
                            width: "500px",
                          }} // Custom styles
                          title={<TooltipContent data={moveOutDetail?.termination} type={2} />}
                        >
                          <ExclamationCircleFilled title={moveOutDetail?.termination?.terminationPaneltyFrom} />
                        </Tooltip>
                      </div>
                      <InputField
                        control={control}
                        disabled={true}
                        setValue={setValue}
                        label="Termination Charges"
                        fieldname="terminationCharges"
                        valueGot={
                          penaltyChangeLoading
                            ? "Loading..."
                            : `${
                                moveOutDetail?.termination?.numberOfDays ? moveOutDetail?.termination?.numberOfDays : 0
                              } days |  ${formatCurrency(moveOutDetail?.termination?.totalterminationPaneltyAmount, {
                                showZeros: true,
                              })}`
                        }
                        validate={errors.terminationCharges && "error"}
                        validMessage={errors.terminationCharges && errors.terminationCharges.message}
                      />
                    </Col>
                  </>
                )}

                <Col span={8}>
                  <InputField
                    control={control}
                    setValue={setValue}
                    disabled={true}
                    label="Settlement Amount"
                    fieldname="settlementAmount"
                    valueGot={` ${formatCurrency(howShowFinalAmount(), { showZeros: true })}`}
                    helpingText={Number(howShowFinalAmount()) > 0 ? "Payable by Tenant" : "Payable to Tenant"}
                  />
                </Col>
              </Row>

              <Row gutter={24} className="footer">
                <Space size="middle">
                  <Button
                    label="Cancel"
                    className="bf-discard-button"
                    onClick={() => props.parentState({ modalPayload: { open: false } })}
                  />

                  <Button type="submit" label="Save" className="cc-fotter_next-button" />
                </Space>
              </Row>
            </Col>
          </Form>
        </>
      )}
    </>
  );
};

export default React.memo(index);
